<p>node-document works!</p>
